import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-[#f5f5f0] border-t-4 border-black py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-black flex items-center justify-center">
              <div className="w-4 h-4 bg-[#d4ff00] rotate-45" />
            </div>
            <span className="font-black text-xl text-black">Evolve</span>
          </div>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            <button type="button" className="font-bold text-black hover:text-black/60 transition-colors cursor-pointer">
              Конфиденциальность
            </button>
            <button type="button" className="font-bold text-black hover:text-black/60 transition-colors cursor-pointer">
              Условия
            </button>
            <button type="button" className="font-bold text-black hover:text-black/60 transition-colors cursor-pointer">
              Контакты
            </button>
          </div>

          {/* Copyright */}
          <div className="text-black/60 font-medium">
            © 2026 Evolve. Все права защищены.
          </div>
        </div>
      </div>
    </footer>
  );
}
